import React from 'react'
import Button from '@mui/material/Button';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { withStyles } from '@material-ui/core/styles';
import Loader from '../components/loader/loader';
import Colors from '../utils/constants/Colors';

function ZButton(props) {
    const classes = props.classes
    return (
        <div className={classes.root}>
            <ThemeProvider theme={theme}>
                <Button
                    {...props}
                    className={props.className}
                    style={props.style}
                    variant={props.variant}
                >
                    {props.loading == true ?
                        <Loader size={15} color={Colors.WHITE} type={'loader'} thickness={2} className={styles.buttonProgress} />
                        :
                        props.name
                    }
                </Button>
            </ThemeProvider>
        </div>
    )
}

const styles = (theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: "4px !important",
        },
        '& button.MuiButton-root': {
            borderRadius: 4,
            fontSize: "1rem",
            fontFamily: "Noto Sans ",
            fontWeight: 400,
            lineHeight: 1.5,
         
            fontWeight: 600,
            minWidth: '7rem',


            // background: "#f7941d",
            '& p': {
                fontSize: "1rem",
                fontFamily: "Noto Sans ",
                fontWeight: 400,
                lineHeight: 1.5,

                '& + span': {
                    right: '1rem',
                    position: 'absolute'
                }
            },
        },

        '& button.MuiButton-root.MuiButton-contained': {
            color:"#fff",
            background: "#f7941d",
            '&:hover': {
                background: "#f7941d",
            },
        },

        '& button.MuiButton-root.MuiButton-outlined': {
            border: "0.5px solid #f7941d",
            color:"#f7941d",
            '&:hover':{
                background: "#fff",
            },
        },


    },
    buttonProgress: {
        // top: "50%",
        // left: " 50%",
        /* position: absolute; */
        // marginTop: "-3px",
        // marginRight: "-74px",
        // marginLeft: "-23px",
        alignSelf: 'center'
    },
    customWidth: {
        fontSize: 14
    },
});

export default withStyles(styles)(ZButton);

const theme = createTheme({
    palette: {
        primary: {
            main: "#303778",
            contrastText: "#fff",
        },
        // secondary: {
        //     main: "#FF9567",
        //     contrastText: "#fff",
        // },
    },
    overrides: {
        MuiButton: {
            containedPrimary: {
                // primary: {
                color: "#fff",
                background: "#303778",
                boxShadow: "none",
                '&:hover': {
                    background: "#303778",
                },
            },
            // containedSecondary: {
            //     '&:hover': {
            //         backgroundColor: "#FF9567",
            //         '@media (hover: none)': {
            //             backgroundColor: "#FF9567",
            //         },
            //     },
            // },

            outlinedPrimary: {
                border: '0.5px solid #303778',
                color: "#303778",
                '&:hover': {
                    backgroundColor: "#fff",
                    '@media (hover: none)': {
                        // border: '0.5px solid',
                        // borderColor: '#00AFEF',
                    },
                },
                focusVisible: {
                    backgroundColor: "#fff",
                },
            },

            // outlinedSecondary: {
            //     border: '0.5px solid #FF9567',
            //     color: "#FF9567",
            //     backgroundColor: "#fff",
            //     '&:hover': {
            //         backgroundColor: "#fff",
            //         '@media (hover: none)': {
            //         },
            //     },
            //     focusVisible:{
            //         backgroundColor: "#fff",
            //     },
            // }
        }
    }
    // }
});


